// extracted by mini-css-extract-plugin
module.exports = {"button":"Tabs_button__2RIHu","selectedButton":"Tabs_selectedButton__1Lyd1","hideInMobile":"Tabs_hideInMobile__3eQ2O"};